import * as React from "react";
import { forwardRef } from "react";
const SvgColumn = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} ref={ref} aria-labelledby={titleId} aria-describedby={descId} {...props}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path fill="#232F3E" d="M20 20H0V0h20zm-6-1.905h4V1.905h-4zm-2 0V1.905H8v16.19zm-6 0V1.905H2v16.19z" /></svg>;
const ForwardRef = forwardRef(SvgColumn);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTIwIDIwSDBWMGgyMHYyMHptLTYtMS45MDQ4aDRWMS45MDQ4aC00djE2LjE5MDR6bS0yIDBWMS45MDQ4SDh2MTYuMTkwNGg0em0tNiAwVjEuOTA0OEgydjE2LjE5MDRoNHoiIGZpbGw9IiMyMzJGM0UiIGZpbGwtcnVsZT0ibm9uemVybyIvPgo8L3N2Zz4K";